// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 18V20H12V18H22ZM22 11V13H12V11H22ZM22 4V6H12V4H22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2C8.20914 2 10 3.79086 10 6C10 7.86384 8.72523 9.42998 7 9.87402V14.126C8.72523 14.57 10 16.1362 10 18C10 20.2091 8.20914 22 6 22C3.79086 22 2 20.2091 2 18C2 16.1362 3.27477 14.57 5 14.126V9.87402C3.27477 9.42998 2 7.86384 2 6C2 3.79086 3.79086 2 6 2Z"}}]};

const ComponentSteps1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-steps-1-filled',
    ref,
    icon: element,
  },
));

ComponentSteps1FilledIcon.displayName = 'ComponentSteps1FilledIcon';

export default ComponentSteps1FilledIcon;
